import React from 'react'
import PropTypes from 'prop-types'

import useIsMobile from '../../hooks/useIsMobile'
import DesktopNavigation from './DesktopNavigation'
import MobileNavigation from './MobileNavigation'

const Navigation = props => {
  const isMobile = useIsMobile()

  return isMobile ? (
    <MobileNavigation {...props} />
  ) : (
    <DesktopNavigation {...props} />
  )
}

Navigation.propTypes = {
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onLogout: PropTypes.func,
  isLoggingOut: PropTypes.bool,
}

export default Navigation
